<template>
  <div>
    <div class="main-content">
      <router-link to="/login">
        <img class="logo" src="img/brand/logo.svg" alt="logo" />
      </router-link>
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div>
    <div class="container login-footer">
      <hr class="divider" />
      <div class="copyright">
        <div class="col-md-12">
          <div class="row business-info">
            <div class="col-md-2 footer-logo">
              <img src="img/brand/white.png" alt="logo" />
            </div>
            <div class="col-md-9">
              <div class="row">상호명: 에이아이링고(주) | 대표자명: 이재욱 | 주소: 서울시 강남구 언주로113길 7, 417호</div>
              <div class="row">사업자 등록번호: 727-86-01734 | 통신판매업신고: 2022-서울강남-02721</div>
              <div class="row">Tel: 02-2135-3633 | e-mail: contact@ailinggo.ai</div>
              <div class="row">&copy; {{ new Date().getFullYear() }} AILingGo</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from 'vue2-transitions'

export default {
  components: {
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black',
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
    }
  },
  computed: {
    title() {
      return `${this.$route.name} Page`
    },
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open')
      this.showMenu = !this.showMenu
    },
    closeMenu() {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },
    setBackgroundColor() {
      document.body.classList.add('bg-default')
    },
    removeBackgroundColor() {
      document.body.classList.remove('bg-default')
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor()
      } else {
        this.removeBackgroundColor()
      }
    },
  },
  beforeDestroy() {
    this.removeBackgroundColor()
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu()
      setTimeout(() => {
        next()
      }, this.menuTransitionDuration)
    } else {
      next()
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function() {
        this.updateBackground()
      },
    },
  },
}
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}

.logo {
  width: 97.97px;
  height: 30px;
  position: absolute;
  z-index: 1;
  top: 16px;
  left: 16px;
}

.business-info {
  align-items: center;
  text-align: center;
  font-size: 0.8em;
  min-width: 470px;
}

.footer-logo {
  min-width: 160px;
  img {
    height: 40px;
  }
}

.divider {
  background: white;
}

.login-footer {
  color: white;
  margin-bottom: 20px;
}
</style>
